// extracted by mini-css-extract-plugin
export default {"multiplechoicescreen":"MultipleChoiceScreen_multiplechoicescreen__4x52q","multiplechoicescreen-choices":"MultipleChoiceScreen_multiplechoicescreen-choices__OmgKo"};